<template>
  <main class="overflow-hidden">
    <PreviewSection />
    <ContentSectionStableCoinExplanation />
    <ContentSectionProtocolExplanation />
    <ContentSectionTwo />
    <ContentSectionOne />
    <ContentSectionThree />
    <ContentSectionFour />
    <ContentSectionLast />
  </main>
</template>

<script setup>
const config = useRuntimeConfig()

useHead({
  link: [
    {
      rel: 'canonical',
      href: config.public.appBaseUrl
    },
    {
      rel: 'preload',
      as: 'image',
      href: '/preview_section_mask.webp',
    },
  ]
})

useSeoMeta({
  title: getContent('seo.home_title'),
  description: getContent('seo.home_meta_description'),
  ogTitle: getContent('seo.home_meta_og_title'),
  ogDescription: getContent('seo.home_meta_og_description'),
  ogUrl: config.public.appBaseUrl
})
</script>